// pages/locations/LocationPage.js

import React, { useEffect, useState } from 'react'
import api from '../../services/api'
import { useGlobal } from '../../context/GlobalContext'
import LocationList from './LocationList'
import LocationCreateModal from './LocationCreateModal'
import '../../assets/css/LocationPage.css'

function LocationPage() {
  const [sites, setSites] = useState([])
  const [selectedSiteId, setSelectedSiteId] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)
  const { showLoading, hideLoading, showMessage } = useGlobal()

  const fetchSites = async () => {
    showLoading()
    try {
      const res = await api.get('/site/all')
      setSites(res.data.sites || [])
    } catch {
      showMessage('Error fetching sites', 'error')
    }
    hideLoading()
  }

  useEffect(() => {
    fetchSites()
  }, [])

  const handleSiteChange = e => {
    setSelectedSiteId(e.target.value)
  }

  const handleAddLocationClick = () => {
    if (!selectedSiteId) {
      showMessage('Select a site first', 'error')
      return
    }
    setShowModal(true)
  }

  const handleLocationCreated = () => {
    setShowModal(false)
    setRefreshKey(prev => prev + 1)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  return (
    <div className="location-page-container">
      <h2 className="location-title">Manage Locations</h2>
      <div className="location-form-group">
        <label className="location-label">Select Site</label>
        <select
          className="location-select"
          value={selectedSiteId}
          onChange={handleSiteChange}
        >
          <option value="">-- Choose --</option>
          {sites.map(site => (
            <option key={site._id} value={site._id}>
              {site.plainName} - {site.address}
            </option>
          ))}
        </select>
      </div>
      <button className="location-btn" onClick={handleAddLocationClick}>
        Add New Location
      </button>
      <LocationList siteId={selectedSiteId} refreshKey={refreshKey} />
      {showModal && (
        <LocationCreateModal
          siteId={selectedSiteId}
          onCreated={handleLocationCreated}
          onClose={handleCloseModal}
        />
      )}
    </div>
  )
}

export default LocationPage